import { motion } from "framer-motion"
import { cn } from "@/lib/utils"
import { LucideIcon } from "lucide-react"

interface BenefitCardProps {
  title: string
  description: string
  icon: LucideIcon
  iconColor: string
  className?: string
}

const motionVariants = {
  hidden: { opacity: 0, y: 20 },
  show: { opacity: 1, y: 0 },
  hover: {
    scale: 1.02,
    transition: { duration: 0.2 }
  }
};

export function BenefitCard({ 
  title, 
  description, 
  icon: Icon,
  iconColor,
  className 
}: BenefitCardProps) {
  return (
    <motion.div
      variants={motionVariants}
      whileHover="hover"
      className={cn(
        "p-8 rounded-xl",
        "bg-card",
        "border border-border",
        "hover:shadow-neumorphic transition-all duration-300",
        className
      )}
    >
      <div className={cn(
        "p-4 rounded-xl w-fit mb-6",
        "bg-background",
        "border border-border"
      )}>
        <Icon className={cn("w-8 h-8", iconColor)} />
      </div>
      <h3 className="text-h4 mb-4">
        {title}
      </h3>
      <p className="text-body">
        {description}
      </p>
    </motion.div>
  )
} 